import React from 'react'
import { FormGroup, Label, FormFeedback, Button, ButtonGroup } from 'reactstrap'
import { useField, useFormikContext } from 'formik'
import cn from 'classnames'

const RadioButtons = ({ label, ...props }) => {
  const name = (props.field && props.field.name) || props.name
  const [field, meta] = useField(name)
  const { setFieldValue } = useFormikContext()

  return (
    <FormGroup className={meta.touched && meta.error ? 'has-error' : ''}>
      {label && (
        <Label className="form-label" htmlFor={props.id || props.name}>
          {label}
        </Label>
      )}
      <div className="clearfix"></div>

      <ButtonGroup className={props.btnBlock ? 'w-100' : ''}>
        {props.values.map(({ label, value }) => (
          <Button
            color="dark"
            active={value === field.value}
            key={value}
            type="button"
            className="text-white"
            onClick={() => setFieldValue(field.name, value)}
          >
            <i
              className={cn(
                'fa',
                'me-2',
                value === field.value ? 'fa-dot-circle' : 'fa-circle'
              )}
            />
            {label}
          </Button>
        ))}
      </ButtonGroup>

      {meta.touched && meta.error ? (
        <FormFeedback className="d-block">{meta.error}</FormFeedback>
      ) : null}
    </FormGroup>
  )
}

export default RadioButtons
